import styled from 'src/style';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

export const EventContainer = styled.div(
  {
    maxWidth: 540,
    minHeight: 40,
    position: 'relative',
    backgroundColor: colors.white,
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 32,
    marginBottom: 8,
    cursor: 'pointer',
    transitionProperty: 'all',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'cubic-bezier(0.41, 0.094, 0.54, 0.07)',
    transitionDelay: '0s',
    overflow: 'hidden',
    boxSizing: 'content-box',
    [mediaQueries.phoneOnly]: {
      padding: '20px 20px 20px 30px',
    },
  },
  ({ isHover }) => ({
    ...(isHover ? { paddingLeft: 45 } : {}),
    boxShadow: isHover ? '0 10px 15px rgba(0,0,0,.09)' : '0 5px 15px rgba(0,0,0,.07)',
  })
);

export const YellowLineHover = styled.div(
  {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: 10,
    borderRadius: '10px 0px 0px 10px',
    backgroundColor: colors.yellow,
    transitionProperty: 'all',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'cubic-bezier(0.41, 0.094, 0.54, 0.07)',
  },
  ({ isHover }) => ({
    transform: isHover ? 'translateX(0px)' : 'translateX(-20px)',
  })
);
